import React, { useState } from 'react';
import { ArrowRight, CheckIcon } from 'lucide-react';
import { DS } from '../ds';
import { AlinovaConstellation } from '../Visuals';
import { Label, H, P, Btn } from '../Primitives';
export const PlansSection = () => {
  const [hoveredPlan, setHoveredPlan] = useState<string | null>(null);
  const plans = [{
    name: 'Fabricación',
    audience: 'Para ortodoncistas con flujo digital propio',
    subtitle: 'Tú planeas, nosotros fabricamos',
    price: '$1.500.000',
    unit: 'desde / por caso',
    featured: false,
    features: ['Fabricación desde tus archivos STL', 'Material biocompatible certificado', 'Control de calidad por unidad', 'Kit eco-premium incluido', 'Retenedores finales'],
    cta: 'Cotizar fabricación'
  }, {
    name: 'Integral',
    audience: 'Para clínicas que inician ortodoncia invisible',
    subtitle: 'Nos encargamos de todo',
    price: '$2.000.000',
    unit: 'desde / por caso',
    featured: true,
    features: ['Diagnóstico digital completo', 'Planificación y setup virtual', 'Validación profesional', 'Fabricación y control QA', 'Kit eco-premium incluido', 'Soporte durante el tratamiento'],
    cta: 'Empezar solución integral'
  }, {
    name: 'Pedido flexible',
    audience: 'Para clínicas con necesidades puntuales',
    subtitle: 'Paga solo lo que necesitas',
    price: '$80.000',
    unit: 'desde / componente',
    featured: false,
    features: ['Placas individuales', 'Retenedores sueltos', 'Solo planificación digital', 'Cotización inmediata', 'Sin compromiso de volumen'],
    cta: 'Cotizar'
  }];
  return <section id="planes" style={{
    padding: '40px 24px 48px',
    background: DS.color.ivory
  }} data-id="element-684" data-mp="2v3g62u58aya9">
      <div style={{
      maxWidth: '1200px',
      margin: '0 auto'
    }} data-id="element-685" data-mp="3029i0i4vah8b">
        {/* Header — más transaccional */}
        <div style={{
        textAlign: 'center',
        maxWidth: '640px',
        margin: '0 auto 56px'
      }} data-id="element-686" data-mp="77j4zzaw099m">
          <div style={{
          display: 'flex',
          justifyContent: 'center'
        }} data-id="element-687" data-mp="g8h17vf33chn">
            <Label data-id="element-688" data-mp="b8ukvd3ylg4m">Precios y planes</Label>
          </div>
          <H size="lg" align="center" data-id="element-689" data-mp="b82x2oglsmow">
            Precios claros, sin sorpresas
          </H>
          <div style={{
          marginTop: '14px',
          display: 'flex',
          justifyContent: 'center'
        }} data-id="element-690" data-mp="q4u1jc54wold">
            <P align="center" maxWidth="480px" data-id="element-691" data-mp="yyymjexl75sz">
              Todo en pesos colombianos. Sin costos ocultos ni compromisos
              de volumen. Empieza con un solo caso.
            </P>
          </div>

          {/* Trust pills */}
          <div style={{
          marginTop: '24px',
          display: 'flex',
          justifyContent: 'center',
          gap: '12px',
          flexWrap: 'wrap'
        }} data-id="element-692" data-mp="18x4o1vfhe9xb">
            {['Sin contrato de exclusividad', 'Primer caso sin compromiso', 'Respuesta en 24h'].map(pill => <span key={pill} style={{
            padding: '6px 16px',
            borderRadius: DS.radius.pill,
            background: DS.color.mint,
            border: `1px solid ${DS.color.aqua}40`,
            fontFamily: DS.font.body,
            fontSize: '12px',
            fontWeight: 600,
            color: DS.color.tealDeep
          }} data-id="element-693" data-mp="1dkma7a300sgl">
                {pill}
              </span>)}
          </div>
        </div>

        {/* Cards */}
        <div className="col-3" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '24px',
        alignItems: 'stretch'
      }} data-id="element-694" data-mp="ltg7qmzt2io5">
          {plans.map(plan => {
          const featured = plan.featured;
          const hovered = hoveredPlan === plan.name;
          return <div key={plan.name} onMouseEnter={() => setHoveredPlan(plan.name)} onMouseLeave={() => setHoveredPlan(null)} style={{
            position: 'relative',
            borderRadius: DS.radius.cardLg,
            padding: '38px 30px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: featured ? `linear-gradient(165deg, ${DS.color.tealDeep} 0%, #07202a 100%)` : '#fff',
            border: `1.5px solid ${featured ? DS.color.tealDeep : hovered ? DS.color.aqua + '60' : DS.color.border}`,
            boxShadow: featured ? hovered ? '0 40px 100px rgba(13,59,80,0.38)' : DS.shadow.featured : hovered ? DS.shadow.cardHover : DS.shadow.card,
            transform: featured ? hovered ? 'scale(1.04)' : 'scale(1.02)' : hovered ? 'translateY(-4px)' : 'none',
            transition: `all 0.28s ${DS.ease.smooth}`
          }} data-id="element-695" data-mp="92jxsa98o08f">
                {featured && <AlinovaConstellation width={220} height={220} opacity={0.07} style={{
              position: 'absolute',
              top: '-40px',
              right: '-40px',
              pointerEvents: 'none'
            }} data-id="element-696" data-mp="1j130973yyaj6" />}

                {featured && <div style={{
              position: 'relative',
              zIndex: 1,
              alignSelf: 'flex-start',
              marginBottom: '18px',
              padding: '5px 14px',
              borderRadius: DS.radius.pill,
              background: `linear-gradient(135deg, ${DS.color.aquaLight}, ${DS.color.aqua})`,
              fontFamily: DS.font.body,
              fontSize: '10px',
              fontWeight: 800,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: DS.color.tealDeep,
              whiteSpace: 'nowrap'
            }} data-id="element-697" data-mp="1zror2stq376t">
                    Más elegido
                  </div>}

                <div style={{
              position: 'relative',
              zIndex: 1
            }} data-id="element-698" data-mp="39yui1h5bflyy">
                  {/* Audiencia — para quién es */}
                  <div style={{
                fontFamily: DS.font.body,
                fontSize: '11px',
                fontWeight: 600,
                color: featured ? DS.color.aquaLight : DS.color.teal,
                marginBottom: '8px',
                letterSpacing: '0.01em'
              }} data-id="element-699" data-mp="3eq2rueak59cn">
                    {plan.audience}
                  </div>

                  <div style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '1.4rem',
                color: featured ? '#fff' : DS.color.ink
              }} data-id="element-700" data-mp="1i9dqdnmph26">
                    {plan.name}
                  </div>

                  <div style={{
                fontFamily: DS.font.body,
                fontSize: '13px',
                color: featured ? 'rgba(255,255,255,0.55)' : DS.color.muted,
                marginTop: '4px'
              }} data-id="element-701" data-mp="2cblp512zjamx">
                    {plan.subtitle}
                  </div>

                  {/* Separador */}
                  <div style={{
                margin: '20px 0',
                height: '1px',
                background: featured ? 'rgba(255,255,255,0.08)' : DS.color.border
              }} data-id="element-702" data-mp="2pzf9cgvfez2o" />

                  {/* Precio */}
                  <div style={{
                marginBottom: '24px',
                display: 'flex',
                alignItems: 'baseline',
                gap: '8px'
              }} data-id="element-703" data-mp="3dv064iq9956w">
                    <span style={{
                  fontFamily: DS.font.heading,
                  fontWeight: 700,
                  fontSize: '2.2rem',
                  color: featured ? DS.color.aquaLight : DS.color.tealDeep,
                  lineHeight: 1
                }} data-id="element-704" data-mp="5grk5ti8ncnp">
                      {plan.price}
                    </span>
                    <span style={{
                  fontFamily: DS.font.body,
                  fontSize: '13px',
                  color: featured ? 'rgba(255,255,255,0.5)' : DS.color.muted
                }} data-id="element-705" data-mp="qsqfxsa6qiae">
                      {plan.unit}
                    </span>
                  </div>

                  {/* Features */}
                  <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '11px',
                marginBottom: '28px'
              }} data-id="element-706" data-mp="1ehjdtuadb07n">
                    {plan.features.map(f => <div key={f} style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }} data-id="element-707" data-mp="3cj7gpqxwwwxa">
                        <span style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    flexShrink: 0,
                    marginTop: '1px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: featured ? 'rgba(75,199,210,0.15)' : DS.color.mint
                  }} data-id="element-708" data-mp="3qb5jlk115wl0">
                          <CheckIcon size={12} color={featured ? DS.color.aquaLight : DS.color.teal} strokeWidth={3} data-id="element-709" data-mp="s0ajh7dvj2lh" />
                        </span>
                        <span style={{
                    fontFamily: DS.font.body,
                    fontSize: '14px',
                    color: featured ? 'rgba(255,255,255,0.8)' : DS.color.ink,
                    lineHeight: 1.5
                  }} data-id="element-710" data-mp="e7ubrta12ge8">
                          {f}
                        </span>
                      </div>)}
                  </div>
                </div>

                {/* CTA */}
                <div style={{
              marginTop: 'auto',
              position: 'relative',
              zIndex: 1
            }} data-id="element-711" data-mp="3hokoss411tpf">
                  <Btn variant={featured ? 'aqua' : 'secondary'} size="md" fullWidth href={DS.wa} data-id="element-712" data-mp="3o4ullm4ruwa1">
                    <span style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }} data-id="element-713" data-mp="3f44swrat5m0j">
                      {plan.cta}
                      <ArrowRight size={15} aria-hidden="true" data-id="element-714" data-mp="2reu2o3r33a0n" />
                    </span>
                  </Btn>
                </div>
              </div>;
        })}
        </div>

        {/* Micro-CTA banner */}
        <div style={{
        marginTop: '48px',
        borderRadius: DS.radius.cardLg,
        padding: '32px 40px',
        background: `linear-gradient(135deg, ${DS.color.tealDeep}08 0%, ${DS.color.aqua}12 100%)`,
        border: `1.5px solid ${DS.color.aqua}30`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px',
        flexWrap: 'wrap'
      }} data-id="element-715" data-mp="2hhfknzpiid68">
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px'
        }} data-id="element-716" data-mp="27s8wfuwr2rb0">
            <div aria-hidden="true" style={{
            width: '44px',
            height: '44px',
            borderRadius: '50%',
            background: `${DS.color.aqua}18`,
            border: `1px solid ${DS.color.aqua}30`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }} data-id="element-717" data-mp="2lsjo305vw9x8">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" data-id="element-718" data-mp="34jkm9lz6k1fq">
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke={DS.color.aqua} strokeWidth="1.5" data-id="element-719" data-mp="30ih9j8cfiliq" />
                <path d="M12 8V12L14.5 14.5" stroke={DS.color.aqua} strokeWidth="1.5" strokeLinecap="round" data-id="element-720" data-mp="12riv3cogukto" />
              </svg>
            </div>
            <div data-id="element-721" data-mp="ewpw8sapioiw">
              <div style={{
              fontFamily: DS.font.heading,
              fontWeight: 700,
              fontSize: '1rem',
              color: DS.color.ink,
              marginBottom: '4px'
            }} data-id="element-722" data-mp="ex81gefckd2y">
                ¿No sabes cuál plan es para ti?
              </div>
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '14px',
              color: DS.color.muted
            }} data-id="element-723" data-mp="stcvj1q4tqrz">
                Cuéntanos tu caso y te recomendamos la mejor opción en menos de 24h.
              </div>
            </div>
          </div>
          <Btn variant="secondary" size="md" href={DS.wa} data-id="element-724" data-mp="3kr1tc2dm9dcg">
            <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }} data-id="element-725" data-mp="3kto2u7k2i2xb">
              Hablar con un asesor
              <ArrowRight size={15} aria-hidden="true" data-id="element-726" data-mp="3b1qnqppxuqtb" />
            </span>
          </Btn>
        </div>
      </div>
    </section>;
};